import { Divider, Text } from "@ilc-technology/luik";
import React from "react";
import Surface from "../Surface/Surface";
import TitleValueCell from "./TitleValueCell";
import { FormattedMoney } from "../../Common/Helpers/MoneyHelper";
import { Money } from "../../Common/Types";

interface InfoCardProps {
  summary: React.ReactNode;
  destinationName: string;
  contentText?: React.ReactNode;
  priceFooterElement?: React.ReactNode;
  currencySelector?: React.ReactNode;

  amountLabel: string;
  amount: Money;

  topChildren?: React.ReactNode;
  bottomChildren?: React.ReactNode;
}

export function renderContent(text?: React.ReactNode, testId?: string, className?: string) {
  if (!text) return null;
  return (
    <Text variant="paragraph-small-body" data-testid={testId} className={className}>
      {text}
    </Text>
  );
}
const InfoCard: React.FC<InfoCardProps> = ({
  destinationName,
  contentText,
  priceFooterElement,
  currencySelector,
  summary,
  amountLabel,
  amount,
  topChildren,
  bottomChildren,
}) => {
  const getBorderRadius = (top?: React.ReactNode, bottom?: React.ReactNode) => {
    if (top && bottom) {
      return "none";
    } else if (top && !bottom) {
      return "bottom";
    } else if (!top && bottom) {
      return "top";
    } else {
      return "all";
    }
  };

  return (
    <div data-testid="payment-summary-card">
      {topChildren}
      <Surface borderRadius={getBorderRadius(topChildren, bottomChildren)}>
        <div className="a-space-y-sm">
          {currencySelector}
          <div className="a-space-y-sm">
            <Text variant="special-eyebrow" data-testid="psc-summary-text">
              {summary}
            </Text>
            <Text variant="heading-5-bold" data-testid="psc-destination-text">
              {destinationName}
            </Text>
            {renderContent(contentText, "psc-content-text")}
          </div>
          <Divider light />
          <TitleValueCell leftTextValue={amountLabel} rightTextValue={FormattedMoney(amount)} testId="psc-total" />
          {priceFooterElement}
        </div>
      </Surface>
      {bottomChildren}
    </div>
  );
};

export default InfoCard;
